import { z } from "zod";
import { DataIdSchema } from "./auth";

export const MESSAGE_TAG = {
	REQUEST: "REQUEST",
	HANDOVER: "handover",
	DIAGNOSIS: "diagnosis",
	MORE: "MORE",
	RESPOND: "RESPOND",
	PUBLISH: "publish",
	PUBLISH_OPTION: "publish-option",
	QUESTION: "question",
	PATIENT: "patient",
	SUMMARY: "summary",
	IMAGING: "Imaging",
	MEDICATION: "medication",
	ALLERGIES: "allergies",
	PHOTOS: "Photos",
	UPLOAD: "Upload",
	RESULTS: "Results",
	OTHER: "Other",
	POLL: "poll",
	TOPIC: "topic",
	EXTERNAL: "external",
	PLAN: "plan",
	REFERAL: "referral",
	SPECIALISTS_ADVICE: "specialists advice",
	FILES: "files",
	INVITATION: "invitation",
	MEDIA: "media",
	DOCUMENT: "document",
	AI: "hemi",
} as const;

const GetMessageDiscussionsSchema = z.object({
	channel_name: z.string(),
	page: z.number().int().default(1).optional(),
	limit: z.number().int().default(25).optional(),
	search: z.string().optional(),
	tags: z.nativeEnum(MESSAGE_TAG).optional(),
});

export type GetMessageDiscussionsSchema = z.infer<
	typeof GetMessageDiscussionsSchema
>;

export const MessageIdSchema = z.string().uuid();

const MessageDocumentSchema = z.object({
	file_id: z.string(),
	filename: z.string(),
	display_name: z.string(),
	tags: z.string(),
	ocr_flag: z.boolean().default(false),
});

export type MessageDocumentSchema = z.infer<typeof MessageDocumentSchema>;

const MessagePreviewSchema = z.object({
	link: z.string().url(),
	title: z.string(),
	description: z.string().optional(),
	image_url: z.string().url().optional(),
	bulletin_type: z.enum(["link", "file"]),
});

export type MessagePreviewSchema = z.infer<typeof MessagePreviewSchema>;

export const PostCreateMessageBodySchema = z.object({
	id: MessageIdSchema.optional(),
	channel_name: z.string(),
	messageable_id: z.string().optional(),
	messageable_type: z.string().optional(),
	text: z.string().optional(),
	tags: z.nativeEnum(MESSAGE_TAG).nullable().optional(),
	mentions: z.array(DataIdSchema).optional(),
	reply_to: z.string().optional(),
	id_team: z.string().optional(),
	parent_id: z.number().int().optional(),
	documents: z.array(MessageDocumentSchema).optional(),
	preview: MessagePreviewSchema.optional(),
	/**
	 * Exclude this when sending a message
	 */
	files: z.any().optional(),
	message: z.any().optional(),
	document_tags: z.nativeEnum(MESSAGE_TAG).nullable().optional(),
});

export type PostCreateMessageBodySchema = z.infer<
	typeof PostCreateMessageBodySchema
>;

export const PatchUpdateMessageBodySchema = z.object({
	id: DataIdSchema,
	sent: z.boolean().optional(),
	delivered: z.boolean().optional(),
	strike: z.boolean().optional(),
	/**
	 * remove when send to api
	 */
	channelName: z.string(),
	messageable_id: DataIdSchema.optional(),
});

export type PatchUpdateMessageBodySchema = z.infer<
	typeof PatchUpdateMessageBodySchema
>;

export const GetDeleteMessageBodySchema = z.object({
	id: DataIdSchema,
	/**
	 * remove when send to api
	 */
	channelName: z.string(),
});

export type GetDeleteMessageBodySchema = z.infer<
	typeof GetDeleteMessageBodySchema
>;

export const PostReadMessagePayloadSchema = z.object({
	channel_name: z.string(),
	message_ids: z.array(z.string()).optional(),
	message_id: DataIdSchema.optional(),
});

export type PostReadMessagePayloadSchema = z.infer<
	typeof PostReadMessagePayloadSchema
>;

export const SyncMessageParamsSchema = z.object({
	last_requested_at: z.number().int(),
	page: z.number().int().optional(),
	limit: z.number().int().optional(),
});

export type SyncMessageParamsSchema = z.infer<typeof SyncMessageParamsSchema>;
